export const timeAgo = (timestamp) => {
  const seconds = Math.floor((new Date() - new Date(timestamp)) / 1000);

  let interval = seconds / 31536000; // years
  if (interval > 1) return Math.floor(interval) + ' Years Ago';
  
  interval = seconds / 2592000; // months
  if (interval > 1) return Math.floor(interval) + ' Months Ago';
  
  interval = seconds / 86400; // days
  if (interval > 1) return Math.floor(interval) + ' Days Ago';
  
  interval = seconds / 3600; // hours
  if (interval > 1) return Math.floor(interval) + ' Hours Ago';
  
  interval = seconds / 60; // minutes
  if (interval > 1) return Math.floor(interval) + ' Minutes Ago';
  
  if (seconds < 10) return 'Just Now';
  
  return Math.floor(seconds) + ' Seconds Ago';
}; 